__turbopack_context__.v({
  "className": "inter_f864c54e-module__2kH04G__className",
});
